/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{TextureCoordinateType as e,TextureCoordinateAttribute as t}from"./TextureCoordinateAttribute.glsl.js";import{TextureAtlasLookup as o}from"../util/TextureAtlasLookup.glsl.js";import{glsl as r}from"../../shaderModules/interfaces.js";function u(u,n){const{textureCoordinateType:s}=n;if(s===e.None||s===e.COUNT)return;u.include(t,n);const i=s===e.Atlas;i&&u.include(o),u.fragment.code.add(r`
    vec4 textureLookup(sampler2D tex, vec2 uv) {
      return ${i?"textureAtlasLookup(tex, uv, vuvRegion)":"texture(tex, uv)"};
    }
  `)}export{u as VertexTextureCoordinates};
